module.exports = __webpack_public_path__ + "img/t_icon_2.753b73ad.svg";